(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.ZugAcrylicCarrier = api;
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  var STRATEGY = 'native_product_base_plus_exact_cent_adjustments';
  var KEYCHAIN_NATIVE_STRATEGY = 'acrylic_keychain_native_units';
  var KEYCHAIN_NATIVE_CONTRACT = 'acrylic_keychain_native_units_v1';
  var KEYCHAIN_CONFIGURED_ORDER_STRATEGY = 'native_configured_order_variant';
  var KEYCHAIN_CONFIGURED_ORDER_CONTRACT = 'acrylic_keychain_configured_order_v1';
  var PIN_CONFIGURED_ORDER_STRATEGY = 'native_configured_order_variant';
  var PIN_CONFIGURED_ORDER_CONTRACT = 'acrylic_pin_configured_order_v1';
  var CHARM_CONFIGURED_ORDER_STRATEGY = 'native_configured_order_variant';
  var CHARM_CONFIGURED_ORDER_CONTRACT = 'acrylic_charm_configured_order_v1';

  function positiveInteger(value) {
    var number = Number(value);
    return Number.isInteger(number) && number > 0 ? number : 0;
  }

  function nonNegativeInteger(value) {
    var number = Number(value);
    return Number.isInteger(number) && number >= 0 ? number : -1;
  }

  function positiveNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) && number > 0 ? number : 0;
  }

  function adjustmentVariantId(contract, key) {
    if (!contract || !contract.adjustment) return 0;
    return positiveInteger(contract.adjustment[key]);
  }

  function normalizedText(value) {
    return String(value == null ? '' : value).trim();
  }

  function sameNumber(left, right) {
    return Math.abs(Number(left) - Number(right)) < 0.000001;
  }

  function parseConfiguredSizeLabel(value) {
    var match = normalizedText(value).match(/^([0-9]+(?:\.[0-9]+)?)\s*["\u201d]?\s*[x\u00d7]\s*([0-9]+(?:\.[0-9]+)?)\s*["\u201d]?$/i);
    if (!match) return null;
    return {
      widthIn: positiveNumber(match[1]),
      heightIn: positiveNumber(match[2])
    };
  }

  function firstConfiguredValue(properties, keys) {
    for (var index = 0; index < keys.length; index += 1) {
      var value = normalizedText(properties[keys[index]]);
      if (value) return value;
    }
    return '';
  }

  function buildConfiguredOrderProperties(inputProperties, uid) {
    var input = inputProperties || {};
    var output = {
      '_calc_line_uid': uid
    };

    function copy(key, value) {
      var normalized = normalizedText(value);
      if (normalized) output[key] = normalized;
    }

    copy('Shape', firstConfiguredValue(input, ['Shape', '_shape']));
    copy('Finished Size', input['Finished Size']);
    copy('Pieces', input.Pieces);
    copy('Material', firstConfiguredValue(input, ['Material', 'Material / Thickness']));
    copy('Print Style', firstConfiguredValue(input, ['Print Style', 'Print Side']));
    copy('Hardware', input.Hardware);
    copy('Hole', firstConfiguredValue(input, ['Hole', 'Hole Placement']));
    copy('Turnaround', input.Turnaround);

    var artworkStatus = normalizedText(input['Artwork Status']);
    var previousOrder = normalizedText(input._previous_order_number);
    if (artworkStatus === 'Reorder' && previousOrder) {
      artworkStatus += ' — ' + previousOrder;
    }
    copy('Artwork Status', artworkStatus);

    copy('_original_artwork', firstConfiguredValue(input, [
      '_original_artwork',
      '_artwork_original_url'
    ]));
    copy('_proof_preview', firstConfiguredValue(input, [
      '_proof_preview',
      '_line_item_thumbnail',
      '_dcf_preview_url'
    ]));

    // A non-empty customer note is an active artwork-workflow dependency.
    copy('_artwork_note', input._artwork_note);

    return output;
  }

  function keychainNativeRates(contract) {
    if (!contract || !Array.isArray(contract.rates)) return [];
    return contract.rates.map(function (rate) {
      return {
        key: normalizedText(rate && rate.key),
        variantId: positiveInteger(rate && rate.variantId),
        priceCents: positiveInteger(rate && rate.priceCents),
        sku: normalizedText(rate && rate.sku),
        title: normalizedText(rate && rate.title)
      };
    });
  }

  function validateKeychainNativeContract(input) {
    var contract = input && input.contract;
    var expectedSourceProductId = normalizedText(input && input.sourceProductId);
    var rates = keychainNativeRates(contract);
    var seenVariants = {};
    var seenPrices = {};

    if (!contract || contract.enabled !== true ||
        contract.strategy !== KEYCHAIN_NATIVE_STRATEGY ||
        contract.contract !== KEYCHAIN_NATIVE_CONTRACT ||
        normalizedText(contract.subtype) !== 'keychain' ||
        normalizedText(contract.sourceProductId) !== expectedSourceProductId ||
        !positiveInteger(contract.carrierProductId) ||
        positiveInteger(contract.maxQuantity) !== 200000 ||
        positiveInteger(contract.exactThroughCents) !== 200000 ||
        nonNegativeInteger(contract.maxVarianceCents) !== 2 ||
        rates.length !== 2) {
      return false;
    }

    for (var index = 0; index < rates.length; index += 1) {
      var rate = rates[index];
      if (!rate.key || !rate.variantId || !rate.priceCents || !rate.sku || !rate.title ||
          seenVariants[rate.variantId] || seenPrices[rate.priceCents]) {
        return false;
      }
      seenVariants[rate.variantId] = true;
      seenPrices[rate.priceCents] = true;
    }

    return Boolean(seenPrices[1] && seenPrices[5]);
  }

  function resolveKeychainNative(input) {
    input = input || {};
    var contract = input.contract;
    var sourceProductId = normalizedText(input.sourceProductId);
    var targetTotalCents = positiveInteger(input.targetTotalCents);

    if (!validateKeychainNativeContract({
      contract: contract,
      sourceProductId: sourceProductId
    }) || !targetTotalCents) {
      throw new Error('Acrylic Keychain native carrier contract is incomplete.');
    }

    var maxQuantity = positiveInteger(contract.maxQuantity);
    var exactThroughCents = positiveInteger(contract.exactThroughCents);
    var maxVarianceCents = nonNegativeInteger(contract.maxVarianceCents);
    var candidates = [];

    keychainNativeRates(contract).forEach(function (rate) {
      var rawQuantity = targetTotalCents / rate.priceCents;
      var quantities = [Math.floor(rawQuantity), Math.ceil(rawQuantity)];
      quantities.forEach(function (quantity, quantityIndex) {
        if (quantityIndex === 1 && quantities[0] === quantity) return;
        if (!positiveInteger(quantity) || quantity > maxQuantity) return;
        var representedTotalCents = rate.priceCents * quantity;
        candidates.push({
          strategy: KEYCHAIN_NATIVE_STRATEGY,
          contract: KEYCHAIN_NATIVE_CONTRACT,
          productId: positiveInteger(contract.carrierProductId),
          sourceProductId: sourceProductId,
          variantId: rate.variantId,
          rateKey: rate.key,
          rateCents: rate.priceCents,
          sku: rate.sku,
          variantTitle: rate.title,
          encodedQuantity: quantity,
          intendedTotalCents: targetTotalCents,
          authoritativeTotalCents: representedTotalCents,
          varianceCents: representedTotalCents - targetTotalCents
        });
      });
    });

    var exact = candidates.filter(function (candidate) {
      return candidate.varianceCents === 0;
    }).sort(function (a, b) {
      return a.encodedQuantity - b.encodedQuantity ||
        b.rateCents - a.rateCents ||
        a.variantId - b.variantId;
    });
    if (exact.length) return exact[0];

    if (targetTotalCents <= exactThroughCents) {
      throw new Error('Acrylic Keychain total must be exact at or below the approved threshold.');
    }

    var bounded = candidates.filter(function (candidate) {
      return Math.abs(candidate.varianceCents) <= maxVarianceCents;
    }).sort(function (a, b) {
      return Math.abs(a.varianceCents) - Math.abs(b.varianceCents) ||
        a.authoritativeTotalCents - b.authoritativeTotalCents ||
        a.encodedQuantity - b.encodedQuantity ||
        b.rateCents - a.rateCents ||
        a.variantId - b.variantId;
    });

    if (!bounded.length) {
      throw new Error('Acrylic Keychain total exceeds the approved native variance or quantity limit.');
    }
    return bounded[0];
  }

  function buildKeychainNativeLine(input) {
    input = input || {};
    var resolution = input.resolution;
    var uid = normalizedText(input.uid);
    if (!resolution || resolution.strategy !== KEYCHAIN_NATIVE_STRATEGY ||
        resolution.contract !== KEYCHAIN_NATIVE_CONTRACT || !uid ||
        !positiveInteger(resolution.variantId) ||
        !positiveInteger(resolution.encodedQuantity) ||
        resolution.encodedQuantity > 200000 ||
        resolution.authoritativeTotalCents !== resolution.rateCents * resolution.encodedQuantity ||
        Math.abs(resolution.varianceCents) > 2) {
      throw new Error('Acrylic Keychain native line cannot be built from this resolution.');
    }

    var properties = Object.assign({}, input.properties || {}, {
      '_calc_line_uid': uid,
      '_pricing_engine': 'true',
      '_line_type': 'base',
      '_carrier_strategy': KEYCHAIN_NATIVE_STRATEGY,
      '_carrier_contract': KEYCHAIN_NATIVE_CONTRACT,
      '_carrier_source_product_id': normalizedText(resolution.sourceProductId),
      '_carrier_product_id': String(resolution.productId),
      '_carrier_rate_cents': String(resolution.rateCents),
      '_carrier_encoded_quantity': String(resolution.encodedQuantity),
      '_bundle_quantity_locked': 'true'
    });
    delete properties.calc_line_uid;

    return {
      items: [{
        id: resolution.variantId,
        quantity: resolution.encodedQuantity,
        properties: properties
      }],
      targetTotalCents: resolution.authoritativeTotalCents,
      intendedTotalCents: resolution.intendedTotalCents,
      varianceCents: resolution.varianceCents,
      rateCents: resolution.rateCents,
      encodedQuantity: resolution.encodedQuantity,
      variantId: resolution.variantId
    };
  }

  function configuredOrderRows(contract) {
    if (!contract || !Array.isArray(contract.rows)) return [];
    return contract.rows.map(function (row) {
      return {
        key: normalizedText(row && row.key),
        sizeKey: normalizedText(row && row.sizeKey),
        sizeLabel: normalizedText(row && row.sizeLabel),
        pieces: positiveInteger(row && row.pieces),
        turnaround: normalizedText(row && row.turnaround),
        turnaroundOption: normalizedText(row && row.turnaroundOption),
        priceCents: positiveInteger(row && row.priceCents),
        variantId: positiveInteger(row && row.variantId),
        sku: normalizedText(row && row.proposedSku),
        variantTitle: normalizedText(row && row.proposedVariantTitle)
      };
    });
  }

  function pinConfiguredOrderRows(contract) {
    var rows = configuredOrderRows(contract);
    return rows.map(function (row, index) {
      var source = contract && contract.rows ? contract.rows[index] : null;
      return Object.assign({}, row, {
        widthIn: positiveNumber(source && source.widthIn),
        heightIn: positiveNumber(source && source.heightIn)
      });
    });
  }

  function validateKeychainConfiguredOrderContract(input) {
    input = input || {};
    var contract = input.contract;
    var expectedSourceProductId = normalizedText(input.sourceProductId);
    var rows = configuredOrderRows(contract);
    var seenKeys = {};
    var seenVariants = {};

    if (!contract || contract.enabled !== true || contract.catalogReady !== true ||
        contract.strategy !== KEYCHAIN_CONFIGURED_ORDER_STRATEGY ||
        contract.contract !== KEYCHAIN_CONFIGURED_ORDER_CONTRACT ||
        normalizedText(contract.sourceProductId) !== expectedSourceProductId ||
        positiveInteger(contract.shopifyQuantity) !== 1 || rows.length !== 105 ||
        positiveInteger(contract.rowCount) !== rows.length) {
      return false;
    }

    for (var index = 0; index < rows.length; index += 1) {
      var row = rows[index];
      if (!row.key || !row.sizeKey || !row.sizeLabel || !row.pieces ||
          !row.turnaround || !row.turnaroundOption || !row.priceCents ||
          !row.variantId || !row.sku || !row.variantTitle ||
          seenKeys[row.key] || seenVariants[row.variantId]) {
        return false;
      }
      if (row.key !== [row.sizeKey, row.pieces, row.turnaround].join('|')) {
        return false;
      }
      seenKeys[row.key] = true;
      seenVariants[row.variantId] = true;
    }
    return true;
  }

  function resolveKeychainConfiguredOrder(input) {
    input = input || {};
    var contract = input.contract;
    var sourceProductId = normalizedText(input.sourceProductId);
    var sizeKey = normalizedText(input.sizeKey);
    var pieces = positiveInteger(input.pieces);
    var turnaround = normalizedText(input.turnaround);

    if (!validateKeychainConfiguredOrderContract({
      contract: contract,
      sourceProductId: sourceProductId
    })) {
      throw new Error('Acrylic Keychain configured-order contract is incomplete.');
    }
    if (!sizeKey || sizeKey === 'custom' || !pieces || !turnaround) {
      throw new Error('Acrylic Keychain configuration is not supported by the native contract.');
    }

    var key = [sizeKey, pieces, turnaround].join('|');
    var matches = configuredOrderRows(contract).filter(function (row) {
      return row.key === key;
    });
    if (matches.length !== 1) {
      throw new Error('Acrylic Keychain configuration does not have one exact native variant.');
    }

    var row = matches[0];
    return {
      strategy: KEYCHAIN_CONFIGURED_ORDER_STRATEGY,
      contract: KEYCHAIN_CONFIGURED_ORDER_CONTRACT,
      sourceProductId: sourceProductId,
      configurationKey: row.key,
      sizeKey: row.sizeKey,
      sizeLabel: row.sizeLabel,
      pieces: row.pieces,
      turnaround: row.turnaround,
      turnaroundOption: row.turnaroundOption,
      variantId: row.variantId,
      sku: row.sku,
      variantTitle: row.variantTitle,
      quantity: 1,
      authoritativeTotalCents: row.priceCents
    };
  }

  function buildKeychainConfiguredOrderLine(input) {
    input = input || {};
    var resolution = input.resolution;
    var uid = normalizedText(input.uid);
    if (!resolution || resolution.strategy !== KEYCHAIN_CONFIGURED_ORDER_STRATEGY ||
        resolution.contract !== KEYCHAIN_CONFIGURED_ORDER_CONTRACT || !uid ||
        !positiveInteger(resolution.variantId) || resolution.quantity !== 1 ||
        !positiveInteger(resolution.authoritativeTotalCents) ||
        !normalizedText(resolution.configurationKey)) {
      throw new Error('Acrylic Keychain configured-order line cannot be built from this resolution.');
    }

    var properties = buildConfiguredOrderProperties(input.properties, uid);

    return {
      items: [{
        id: resolution.variantId,
        quantity: 1,
        properties: properties
      }],
      targetTotalCents: resolution.authoritativeTotalCents,
      variantId: resolution.variantId,
      quantity: 1,
      configurationKey: resolution.configurationKey
    };
  }

  function validatePinConfiguredOrderContract(input) {
    input = input || {};
    var contract = input.contract;
    var expectedSourceProductId = normalizedText(input.sourceProductId);
    var rows = pinConfiguredOrderRows(contract);
    var seenKeys = {};
    var seenVariants = {};

    if (!contract || contract.enabled !== true || contract.catalogReady !== true ||
        contract.strategy !== PIN_CONFIGURED_ORDER_STRATEGY ||
        contract.contract !== PIN_CONFIGURED_ORDER_CONTRACT ||
        normalizedText(contract.sourceProductId) !== expectedSourceProductId ||
        positiveInteger(contract.shopifyQuantity) !== 1 || rows.length !== 105 ||
        positiveInteger(contract.rowCount) !== rows.length) {
      return false;
    }

    for (var index = 0; index < rows.length; index += 1) {
      var row = rows[index];
      if (!row.key || !row.sizeKey || !row.sizeLabel || !row.widthIn || !row.heightIn || !row.pieces ||
          !row.turnaround || !row.turnaroundOption || !row.priceCents ||
          !row.variantId || !row.sku || !row.variantTitle ||
          seenKeys[row.key] || seenVariants[row.variantId]) {
        return false;
      }
      if (row.key !== [row.sizeKey, row.pieces, row.turnaround].join('|')) {
        return false;
      }
      seenKeys[row.key] = true;
      seenVariants[row.variantId] = true;
    }
    return true;
  }

  function resolvePinConfiguredOrder(input) {
    input = input || {};
    var contract = input.contract;
    var sourceProductId = normalizedText(input.sourceProductId);
    var sizeKey = normalizedText(input.sizeKey);
    var widthIn = positiveNumber(input.widthIn);
    var heightIn = positiveNumber(input.heightIn);
    var pieces = positiveInteger(input.pieces);
    var turnaround = normalizedText(input.turnaround);

    if (!validatePinConfiguredOrderContract({
      contract: contract,
      sourceProductId: sourceProductId
    })) {
      throw new Error('Acrylic Pin configured-order contract is incomplete.');
    }
    if (!sizeKey || sizeKey === 'custom' || !widthIn || !heightIn || !pieces || !turnaround) {
      throw new Error('Acrylic Pin configuration is not supported by the native contract.');
    }

    var key = [sizeKey, pieces, turnaround].join('|');
    var matches = pinConfiguredOrderRows(contract).filter(function (row) {
      return row.key === key;
    });
    if (matches.length !== 1) {
      throw new Error('Acrylic Pin configuration does not have one exact native variant.');
    }

    var row = matches[0];
    if (!row.widthIn || !row.heightIn ||
        !sameNumber(widthIn, row.widthIn) || !sameNumber(heightIn, row.heightIn)) {
      throw new Error('Acrylic Pin dimensions do not match the resolved native variant.');
    }
    return {
      strategy: PIN_CONFIGURED_ORDER_STRATEGY,
      contract: PIN_CONFIGURED_ORDER_CONTRACT,
      sourceProductId: sourceProductId,
      configurationKey: row.key,
      sizeKey: row.sizeKey,
      sizeLabel: row.sizeLabel,
      widthIn: row.widthIn,
      heightIn: row.heightIn,
      pieces: row.pieces,
      turnaround: row.turnaround,
      turnaroundOption: row.turnaroundOption,
      variantId: row.variantId,
      sku: row.sku,
      variantTitle: row.variantTitle,
      quantity: 1,
      authoritativeTotalCents: row.priceCents
    };
  }

  function buildPinConfiguredOrderLine(input) {
    input = input || {};
    var resolution = input.resolution;
    var uid = normalizedText(input.uid);
    if (!resolution || resolution.strategy !== PIN_CONFIGURED_ORDER_STRATEGY ||
        resolution.contract !== PIN_CONFIGURED_ORDER_CONTRACT || !uid ||
        !positiveInteger(resolution.variantId) || resolution.quantity !== 1 ||
        !positiveInteger(resolution.authoritativeTotalCents) ||
        !normalizedText(resolution.configurationKey)) {
      throw new Error('Acrylic Pin configured-order line cannot be built from this resolution.');
    }

    var canonical = resolvePinConfiguredOrder({
      contract: input.contract,
      sourceProductId: input.sourceProductId,
      sizeKey: input.sizeKey,
      widthIn: input.widthIn,
      heightIn: input.heightIn,
      pieces: input.pieces,
      turnaround: input.turnaround
    });
    if (canonical.configurationKey !== resolution.configurationKey ||
        canonical.variantId !== resolution.variantId ||
        canonical.authoritativeTotalCents !== resolution.authoritativeTotalCents) {
      throw new Error('Acrylic Pin submission does not match the resolved native variant.');
    }

    var inputProperties = input.properties || {};
    var submittedSize = parseConfiguredSizeLabel(inputProperties['Finished Size']);
    if (!submittedSize ||
        !sameNumber(submittedSize.widthIn, canonical.widthIn) ||
        !sameNumber(submittedSize.heightIn, canonical.heightIn) ||
        positiveInteger(inputProperties.Pieces) !== canonical.pieces ||
        normalizedText(inputProperties.Turnaround) !== canonical.turnaroundOption) {
      throw new Error('Acrylic Pin production properties do not match the resolved native variant.');
    }

    var properties = buildConfiguredOrderProperties(inputProperties, uid);
    properties['Finished Size'] = canonical.widthIn.toFixed(2) + '" x ' + canonical.heightIn.toFixed(2) + '"';
    properties.Pieces = String(canonical.pieces);
    properties.Turnaround = canonical.turnaroundOption;

    return {
      items: [{
        id: canonical.variantId,
        quantity: 1,
        properties: properties
      }],
      targetTotalCents: canonical.authoritativeTotalCents,
      variantId: canonical.variantId,
      quantity: 1,
      configurationKey: canonical.configurationKey
    };
  }

  function validateCharmConfiguredOrderContract(input) {
    input = input || {};
    var contract = input.contract;
    var expectedSourceProductId = normalizedText(input.sourceProductId);
    var rows = configuredOrderRows(contract);
    var seenKeys = {};
    var seenVariants = {};

    if (!contract || contract.enabled !== true || contract.catalogReady !== true ||
        contract.strategy !== CHARM_CONFIGURED_ORDER_STRATEGY ||
        contract.contract !== CHARM_CONFIGURED_ORDER_CONTRACT ||
        normalizedText(contract.sourceProductId) !== expectedSourceProductId ||
        positiveInteger(contract.shopifyQuantity) !== 1 || rows.length !== 105 ||
        positiveInteger(contract.rowCount) !== rows.length) {
      return false;
    }

    for (var index = 0; index < rows.length; index += 1) {
      var row = rows[index];
      if (!row.key || !row.sizeKey || !row.sizeLabel || !row.pieces ||
          !row.turnaround || !row.turnaroundOption || !row.priceCents ||
          !row.variantId || !row.sku || !row.variantTitle ||
          seenKeys[row.key] || seenVariants[row.variantId]) {
        return false;
      }
      if (row.key !== [row.sizeKey, row.pieces, row.turnaround].join('|')) {
        return false;
      }
      seenKeys[row.key] = true;
      seenVariants[row.variantId] = true;
    }
    return true;
  }

  function resolveCharmConfiguredOrder(input) {
    input = input || {};
    var contract = input.contract;
    var sourceProductId = normalizedText(input.sourceProductId);
    var sizeKey = normalizedText(input.sizeKey);
    var pieces = positiveInteger(input.pieces);
    var turnaround = normalizedText(input.turnaround);

    if (!validateCharmConfiguredOrderContract({
      contract: contract,
      sourceProductId: sourceProductId
    })) {
      throw new Error('Acrylic Charm configured-order contract is incomplete.');
    }
    if (!sizeKey || sizeKey === 'custom' || !pieces || !turnaround) {
      throw new Error('Acrylic Charm configuration is not supported by the native contract.');
    }

    var key = [sizeKey, pieces, turnaround].join('|');
    var matches = configuredOrderRows(contract).filter(function (row) {
      return row.key === key;
    });
    if (matches.length !== 1) {
      throw new Error('Acrylic Charm configuration does not have one exact native variant.');
    }

    var row = matches[0];
    return {
      strategy: CHARM_CONFIGURED_ORDER_STRATEGY,
      contract: CHARM_CONFIGURED_ORDER_CONTRACT,
      sourceProductId: sourceProductId,
      configurationKey: row.key,
      sizeKey: row.sizeKey,
      sizeLabel: row.sizeLabel,
      pieces: row.pieces,
      turnaround: row.turnaround,
      turnaroundOption: row.turnaroundOption,
      variantId: row.variantId,
      sku: row.sku,
      variantTitle: row.variantTitle,
      quantity: 1,
      authoritativeTotalCents: row.priceCents
    };
  }

  function buildCharmConfiguredOrderLine(input) {
    input = input || {};
    var resolution = input.resolution;
    var uid = normalizedText(input.uid);
    if (!resolution || resolution.strategy !== CHARM_CONFIGURED_ORDER_STRATEGY ||
        resolution.contract !== CHARM_CONFIGURED_ORDER_CONTRACT || !uid ||
        !positiveInteger(resolution.variantId) || resolution.quantity !== 1 ||
        !positiveInteger(resolution.authoritativeTotalCents) ||
        !normalizedText(resolution.configurationKey)) {
      throw new Error('Acrylic Charm configured-order line cannot be built from this resolution.');
    }

    var properties = buildConfiguredOrderProperties(input.properties, uid);

    return {
      items: [{
        id: resolution.variantId,
        quantity: 1,
        properties: properties
      }],
      targetTotalCents: resolution.authoritativeTotalCents,
      variantId: resolution.variantId,
      quantity: 1,
      configurationKey: resolution.configurationKey
    };
  }

  function validateContract(input) {
    var contract = input && input.contract;
    return Boolean(
      contract &&
      contract.strategy === STRATEGY &&
      positiveInteger(input.baseVariantId) &&
      nonNegativeInteger(input.basePriceCents) >= 0 &&
      input.baseAvailable === true &&
      adjustmentVariantId(contract, 'dollar') &&
      adjustmentVariantId(contract, 'cent')
    );
  }

  function buildBundle(input) {
    if (!validateContract(input)) {
      throw new Error('Acrylic carrier contract is incomplete.');
    }

    var targetTotalCents = positiveInteger(input.targetTotalCents);
    var basePriceCents = nonNegativeInteger(input.basePriceCents);
    var uid = String(input.uid || '').trim();
    var adjustmentCents = targetTotalCents - basePriceCents;

    if (!targetTotalCents || !uid || adjustmentCents < 0) {
      throw new Error('Acrylic target total cannot be represented by the native base carrier.');
    }

    var dollarQuantity = Math.floor(adjustmentCents / 100);
    var centQuantity = adjustmentCents % 100;
    var sharedAdjustmentProperties = {
      '_pricing_engine': 'true',
      '_line_type': 'adjustment',
      '_acrylic_bundle_role': 'adjustment',
      'calc_line_uid': uid
    };
    var items = [{
      id: positiveInteger(input.baseVariantId),
      quantity: 1,
      properties: input.baseProperties || {}
    }];

    if (dollarQuantity > 0) {
      items.push({
        id: adjustmentVariantId(input.contract, 'dollar'),
        quantity: dollarQuantity,
        properties: Object.assign({}, sharedAdjustmentProperties, {
          '_acrylic_adjustment_unit': 'dollar'
        })
      });
    }

    if (centQuantity > 0) {
      items.push({
        id: adjustmentVariantId(input.contract, 'cent'),
        quantity: centQuantity,
        properties: Object.assign({}, sharedAdjustmentProperties, {
          '_acrylic_adjustment_unit': 'cent'
        })
      });
    }

    return {
      items: items,
      targetTotalCents: targetTotalCents,
      basePriceCents: basePriceCents,
      adjustmentCents: adjustmentCents,
      dollarQuantity: dollarQuantity,
      centQuantity: centQuantity
    };
  }

  return {
    STRATEGY: STRATEGY,
    KEYCHAIN_NATIVE_STRATEGY: KEYCHAIN_NATIVE_STRATEGY,
    KEYCHAIN_NATIVE_CONTRACT: KEYCHAIN_NATIVE_CONTRACT,
    KEYCHAIN_CONFIGURED_ORDER_STRATEGY: KEYCHAIN_CONFIGURED_ORDER_STRATEGY,
    KEYCHAIN_CONFIGURED_ORDER_CONTRACT: KEYCHAIN_CONFIGURED_ORDER_CONTRACT,
    PIN_CONFIGURED_ORDER_STRATEGY: PIN_CONFIGURED_ORDER_STRATEGY,
    PIN_CONFIGURED_ORDER_CONTRACT: PIN_CONFIGURED_ORDER_CONTRACT,
    CHARM_CONFIGURED_ORDER_STRATEGY: CHARM_CONFIGURED_ORDER_STRATEGY,
    CHARM_CONFIGURED_ORDER_CONTRACT: CHARM_CONFIGURED_ORDER_CONTRACT,
    validateContract: validateContract,
    buildBundle: buildBundle,
    validateKeychainNativeContract: validateKeychainNativeContract,
    resolveKeychainNative: resolveKeychainNative,
    buildKeychainNativeLine: buildKeychainNativeLine,
    validateKeychainConfiguredOrderContract: validateKeychainConfiguredOrderContract,
    resolveKeychainConfiguredOrder: resolveKeychainConfiguredOrder,
    buildKeychainConfiguredOrderLine: buildKeychainConfiguredOrderLine,
    validatePinConfiguredOrderContract: validatePinConfiguredOrderContract,
    resolvePinConfiguredOrder: resolvePinConfiguredOrder,
    buildPinConfiguredOrderLine: buildPinConfiguredOrderLine,
    validateCharmConfiguredOrderContract: validateCharmConfiguredOrderContract,
    resolveCharmConfiguredOrder: resolveCharmConfiguredOrder,
    buildCharmConfiguredOrderLine: buildCharmConfiguredOrderLine
  };
});
